<template>
  <b-card>
    <b-card-header>
      <strong>{{ bulletin.titulo }} - {{ bulletin.boletinTipo.nombre }}</strong>
    </b-card-header>
    <b-card-body>
      <!-- <div id="rich-text-content" /> -->
      <quill-editor
        v-model="bulletin.contenido"
      />
      <b-row
        class="mt-1"
      >
        <b-col
          cols="12"
          md="6"
        >
          <strong>{{ $t('Bulletin.attached') }}</strong>
          <ul>
            <li
              v-for="item in bulletin.boletinAdjuntos"
              :key="item.boletinAdjuntoId"
            >
              <span
                class="cursor-pointer text-primary"
                @click="downloadFile(item)"
              >
                {{ item.archivo }}.{{ item.extension }}
              </span>
            </li>
          </ul>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <strong>{{ $t('Receivers') }}:</strong>
          <ul>
            <li
              v-for="item in bulletin.boletinDestinatarios"
              :key="item.boletinDestinatarioId"
              class="text-primary"
            >
              {{ item.nombreCompleto }}
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
} from 'bootstrap-vue'
import i18n from '@/libs/i18n'
// import { createEditor } from 'vueditor'
import { saveAs } from 'file-saver'
import { ref } from '@vue/composition-api'
import router from '@/router'
import bulletinService from '@/services/bulletin.service'
import fileService from '@/services/file.service'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,

    quillEditor,
  },
  setup() {
    /* Services */
    const {
      fetchBulletin,
    } = bulletinService()
    const {
      fetchFile,
    } = fileService()
    // const refRichTextContent = ref(null)
    // onMounted(() => {
    //   const richTextEditconfig = {
    //     // toolbar: [
    //     //   'removeFormat', 'undo', '|', 'elements', 'fontName', 'fontSize', 'foreColor', 'backColor',
    //     // ],
    //     fontName: [
    //       { val: 'arial black' },
    //       { val: 'times new roman' },
    //       { val: 'Courier New' },
    //     ],
    //     fontSize: ['12px', '14px', '16px', '18px', '0.8rem', '1.0rem', '1.2rem', '1.5rem', '2.0rem'],
    //     uploadUrl: '',
    //   }
    //   refRichTextContent.value = createEditor('#rich-text-content', richTextEditconfig)
    // })
    const bulletin = ref({ titulo: i18n.t('Bulletin.titleBulletin'), contenido: i18n.t('Bulletin.content'), boletinTipo: { nombre: '' } })
    fetchBulletin(router.currentRoute.params.boletinId, data => {
      // refRichTextContent.value.setContent(data.contenido)
      bulletin.value = data
    })

    const downloadFile = item => {
      fetchFile(item.guid, data => {
        const file = new File([data], `${item.archivo}.${item.extension}`)
        saveAs(file, `${item.archivo}.${item.extension}`)
      })
    }

    return {
      bulletin,
      downloadFile,
    }
  },
}
</script>

<style>

</style>
